{{#if isPipelined}}
virtual function void retire_request_grant();
  {{ requestGrantsVariable.identifier }}.put(1);
endfunction
{{/if}}
